import type { LoanRequest } from '../types/authorization';

type InsuranceAggregates = Pick<
  LoanRequest,
  'bruteAmountInsurance' | 'customAmountInsurance' | 'totalCostInsurance'
>;

/** Total insurance cost in UF (or loan currency) from API aggregate fields. */
export function totalInsuranceCostUf(aggregates: InsuranceAggregates): number {
  return (aggregates.bruteAmountInsurance ?? 0)
    + (aggregates.customAmountInsurance ?? 0)
    + (aggregates.totalCostInsurance ?? 0);
}

export function monthlyInsuranceCostUf(
  loanRequest: InsuranceAggregates & Pick<LoanRequest, 'periods'>,
): number {
  return totalInsuranceCostUf(loanRequest) / loanRequest.periods;
}
